import { render, staticRenderFns } from "./defaultTemplate.vue?vue&type=template&id=069e80d1&scoped=true&"
import script from "./defaultTemplate.vue?vue&type=script&lang=js&"
export * from "./defaultTemplate.vue?vue&type=script&lang=js&"
import style0 from "./defaultTemplate.vue?vue&type=style&index=0&id=069e80d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069e80d1",
  null
  
)

export default component.exports